import { createHttpLink } from "@apollo/client";
import { config } from "../config";

export const httpLink = createHttpLink({
  uri: `${config.serverUrl}${config.grahpqlPath}`,
  credentials: config.credentials,
});
